import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74adf2f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "display-item" }
const _hoisted_2 = { class: "display-items" }
const _hoisted_3 = { class: "display-item-header" }
const _hoisted_4 = { class: "display-item-header" }
const _hoisted_5 = { class: "display-item-description" }
const _hoisted_6 = { style: {"height":"35px","overflow":"hidden","margin-bottom":"2px"} }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "stat-col" }
const _hoisted_9 = { class: "stat-col" }
const _hoisted_10 = { class: "stat-col" }
const _hoisted_11 = { class: "stat-col" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-col" }, null, -1))
const _hoisted_13 = {
  class: "stat-col",
  style: {"margin-top":"45px"}
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "display-item-actions" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_statistic_countdown = _resolveComponent("a-statistic-countdown")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_UpdateCreateCampaignForm = _resolveComponent("UpdateCreateCampaignForm")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "display-item-image",
        style: _normalizeStyle({
				backgroundImage: `url('${_ctx.campaign.logo}')`
			}),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoCampaign(_ctx.campaign.id)))
      }, null, 4),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "display-item-content",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoCampaign(_ctx.campaign.id)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.campaign.name), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.moment(_ctx.campaign.startDate).format("D MMM YYYY")) + " - " + _toDisplayString(_ctx.moment(_ctx.campaign.endDate).format("D MMM YYYY")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.campaign.description), 1)
          ]),
          _createElementVNode("a", {
            href: `${_ctx.userAppURL}/${_ctx.campaign.id}`
          }, [
            _createElementVNode("small", null, _toDisplayString(`${_ctx.userAppURL}/${_ctx.campaign.id.slice(0, 3)}...`), 1)
          ], 8, _hoisted_7)
        ]),
        _createVNode(_component_a_divider, {
          style: {"height":"100%"},
          type: "vertical"
        }),
        _createElementVNode("div", {
          class: "display-item-stats",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoCampaign(_ctx.campaign.id)))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_a_statistic, {
              title: "Registered",
              value: _ctx.campaignStats?.registered
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_statistic, {
              title: "Claimed",
              value: _ctx.campaignStats?.claimed
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_a_statistic, {
              title: "Redeemed",
              value: _ctx.campaignStats?.redeemed
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_statistic, {
              title: "Shared",
              value: _ctx.campaignStats?.shared
            }, null, 8, ["value"])
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            (!_ctx.campaignOver)
              ? (_openBlock(), _createBlock(_component_a_statistic_countdown, {
                  key: 0,
                  format: "HH:mm:ss",
                  value: _ctx.momentDeadline
                }, null, 8, ["value"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, " Campaign over "))
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_a_popover, {
            visible: _ctx.menuVisible,
            "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.menuVisible) = $event)),
            trigger: "click",
            placement: "left"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", {
                class: "menu-option",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openUpdateModal && _ctx.openUpdateModal(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "pen",
                  class: "menu-icon"
                }),
                _createTextVNode(" Edit ")
              ]),
              _createElementVNode("div", {
                class: "menu-option",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.duplicateCampaign()))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "pen",
                  class: "menu-icon"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.loading
									? "Duplicating in progress"
									: "Duplicate"), 1)
              ]),
              _createElementVNode("div", {
                class: "menu-option",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDelete()))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "trash",
                  class: "menu-icon"
                }),
                _createTextVNode(" Delete ")
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                class: "menu-btn",
                shape: "circle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "ellipsis-v",
                    class: "menu-icon"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["visible"])
        ])
      ])
    ]),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showModal,
      title: 'Update Campaign',
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModal = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_UpdateCreateCampaignForm, {
          method: "Update",
          campaign: _ctx.campaign,
          onSaved: _ctx.changesSaved
        }, null, 8, ["campaign", "onSaved"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showDeleteModal,
      title: 'Delete Campaign',
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onCancelDelete()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          message: "Warning",
          description: "Type 'remove permanently' in order delete this campaign.",
          type: "warning",
          "show-icon": ""
        }),
        _hoisted_16,
        _createVNode(_component_a_input, {
          value: _ctx.permanentString,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.permanentString) = $event)),
          placeholder: "Type remove permanently"
        }, null, 8, ["value"]),
        _hoisted_17,
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_a_button, {
            style: {"margin-right":"10px"},
            type: "default",
            onClick: _ctx.onCancelDelete
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            disabled: _ctx.permanentString != 'remove permanently',
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleDelete(_ctx.campaign.id)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Delete")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}